import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api, ApiResponse } from "_/utils";
import { Uuid } from "_/types";

import { KEYS as USER_KEYS } from "_/data/users";
import { KEYS as ORG_KEYS } from "_/data/orgs";

type AvatarEntity = "user" | "org";

export function useUploadAvatar(entity: AvatarEntity) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, file }: { id: Uuid; file: File }) => {
      const url =
        entity === "user"
          ? `/users/${id}/avatar`
          : `/organizations/${id}/avatar`;
      return api.put<ApiResponse<void>>(url, file);
    },
    onSuccess: (_data, vars) => {
      if (entity === "user") {
        void queryClient.invalidateQueries({ queryKey: USER_KEYS.current() });
        void queryClient.invalidateQueries({ queryKey: USER_KEYS.all() });
      } else {
        void queryClient.invalidateQueries({ queryKey: ORG_KEYS.org(vars.id) });
        void queryClient.invalidateQueries({ queryKey: ORG_KEYS.all() });
      }
    },
  });
}

export function useRemoveAvatar(entity: AvatarEntity) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: Uuid }) => {
      const url =
        entity === "user"
          ? `/users/${id}/avatar`
          : `/organizations/${id}/avatar`;
      return api.delete<ApiResponse<void>>(url);
    },
    onSuccess: (_data, vars) => {
      if (entity === "user") {
        void queryClient.invalidateQueries({ queryKey: USER_KEYS.current() });
        void queryClient.invalidateQueries({ queryKey: USER_KEYS.all() });
      } else {
        void queryClient.invalidateQueries({ queryKey: ORG_KEYS.org(vars.id) });
        void queryClient.invalidateQueries({ queryKey: ORG_KEYS.all() });
      }
    },
  });
}
